/* globals elkitorg_config */

import { node_observable_component } from 'common/util/ComponentDecorator';
import CurrencyUtil from "common/util/CurrencyUtil";
import CartUtil from 'common/util/CartUtil';
import ModalUtil from 'common/util/ModalUtil';
import './_cart-page.scss';

@node_observable_component
export default class CartPage {
	static classname = 'cart-page';

	constructor($page) {
		this.$page = $page;

		this.initEventListeners();
		this.findJustOutOfStockItem();
	}

	initEventListeners = () => {
		this.$page.find('.cart-page__clear-btn').on('click', () => {
			if (window.delete_item_modal !== undefined) {
				const $deleteModal = $(window.delete_item_modal);

				$deleteModal.find('.cart-item-delete-modal__btn').data('id', 'all')
				ModalUtil.openContent($deleteModal);
			} else {
				CartUtil.clear().then(() => {
					this.refresh();
				});
			}
		});

		this.$page.find('.cart-item').on('delete_cart_item', function() {
			$(this).closest('.cart-page__item').remove();
		});

		this.$page.find('.cart-item__btn-analog').on('click', function(e) {
			e.preventDefault();
			Cookies.set('to_upselling', 'true');
			if( typeof yaCounter26476791 != 'undefined' ) {
				yaCounter26476791.reachGoal('ANALOG_LIST');
			}

			window.location.href = $(this).attr('href');
		});

		this.$page.find('.cart-page__form').on('submit', function(e) {
			const $exceedItems = $('.cart-item_exceed');
			const $outOfStockItems = $('.cart-item_out-of-stock');

			Cookies.set('cart_submitted', '1');

			if ($exceedItems.length || $outOfStockItems.length) {
				e.preventDefault();
				alert('Заказ не может быть оформлен, так как в корзине находятся товары, которых нет в наличии. Удалите их и попробуйте снова.');
			}
		});

		$(document).on('shop_cart_add shop_cart_update shop_cart_delete', this.handleCart);
		this.$page.on('cleared', this.refresh);
	};


	handleCartAddProduct = () => {
		this.refresh();
	};

	handleCart = (e, response) => {
		var add_affiliate_bonus = 0;
		var add_affiliate_bonus_regexp = new RegExp('^' + elkitorg_config.add_affiliate_bonus_string + '$');

		try {
			add_affiliate_bonus = response.data.add_affiliate_bonus.match(add_affiliate_bonus_regexp)[1] || 0;
		} catch (ignored) {

		}

		var currency_info = elkitorg_config.currency_info[elkitorg_config.currency];
		var affiliate_discount_raw = response.data.affiliate_discount && CurrencyUtil.parse(response.data.affiliate_discount, currency_info, false);
		affiliate_discount_raw = affiliate_discount_raw || 0;
		var discount_raw = CurrencyUtil.parse(response.data.discount, currency_info, false);
		var total_raw = CurrencyUtil.parse(response.data.total, currency_info, false);
		var subtotal_raw = total_raw + discount_raw;

		if (this.isUseAffiliate()) {
			subtotal_raw += affiliate_discount_raw;
		}

		this.setAffiliateDiscount(response.data.affiliate_discount);
		this.setDiscount(discount_raw);
		this.setAddAffiliateBonus(add_affiliate_bonus, total_raw);
		this.setTotal(total_raw);
		this.setSubtotal(subtotal_raw);

		if (+response.data.count === 0) {
			this.refresh(+response.data.count);
		}
	};

	getSummary = () => {
		return this.$page.find('.cart-summary');
	};

	isUseAffiliate = () => {
		return !!this.getSummary().data('use_affiliate');
	};

	destruct = () => {
		$(document).off('shop_cart_add shop_cart_update shop_cart_delete', this.handleCart);
	};

	refresh = (count) => {
		$.ajax({
			url: ''
		}).then((response) => {
			const $response = $(response);
			const $new_page = $response.find('.shop-page').add($response.filter('.shop-page'));
			this.$page.closest('.shop-page').replaceWith($new_page);
			if (count === 0) {
				$('.content__breadcrumbs').remove();
			}
			$('.content__breadcrumbs').hide();
			Update($new_page);
		});
	};

	setTotal = (total) => {
		this.getSummary().trigger('setTotal:parent', {val: total});
	};

	setDiscount = (discount) => {
		this.getSummary().trigger('setDiscount:parent', {val: discount});
	};

	setAffiliateDiscount = (affiliate_discount) => {
		this.getSummary().trigger('setAffiliateDiscount:parent', {val: affiliate_discount});
	};

	setAddAffiliateBonus = (add_affiliate_bonus, total) => {
		this.getSummary().trigger('setAddAffiliateBonus:parent', {val: add_affiliate_bonus, total: total});
	};

	setSubtotal = (subtotal) => {
		this.getSummary().trigger('setSubtotal:parent', {val: subtotal});
	};

	findJustOutOfStockItem = () => {
		if (Cookies.get('cart_submitted') !== undefined) {
			const $justOutOfStockItems = $('.cart-item_just-out-of-stock');

			if ($justOutOfStockItems.length > 0) {
				let itemsNames = [];

				$justOutOfStockItems.each(function () {
					const $item = $(this);
					const itemName = $item.find('.cart-item__name').text();

					itemsNames.push(itemName)
				});

				const message = `К сожалению, ${itemsNames.join(' ')} только что закончил${itemsNames.length > 1 ? 'ись' : 'ся' } на складе и недоступен для заказа. Приносим извинения за неудобства. Пожалуйста, удалите товар${itemsNames.length > 1 ? 'ы' : ''} из корзины, чтобы продолжить.`;
				alert(message);

				ScrollUtil.scrollTo($justOutOfStockItems.first().offset().top - 150);
			}

			Cookies.remove('cart_submitted');
		}
	}

};
